import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    EventEmitter,
    forwardRef,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewEncapsulation
} from '@angular/core';
import get from 'lodash/get';

import { SortableTableHeaderDirective } from './sortable-table-header.directive';
import { ColumnSortData, ColumnSortDirection } from './sortable-table.interface';

@Component({
    selector: 'app-sortable-table',
    templateUrl: './sortable-table.component.html',
    styleUrls: ['./sortable-table.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default
})
export class SortableTableComponent implements OnInit, AfterContentInit, OnDestroy {
    @Input() data: any;
    @ContentChildren(forwardRef(() => SortableTableHeaderDirective), { descendants: true })
    headers: QueryList<SortableTableHeaderDirective>;
    @Output() sort = new EventEmitter<any>();

    constructor() {
        //
    }

    ngAfterContentInit(): void {
        this.headers.forEach((header: SortableTableHeaderDirective) => {
            header.sort.subscribe((sortData: ColumnSortData) => {
                // reset sorting of other headers
                this.headers
                    .filter((h: SortableTableHeaderDirective) => h !== header)
                    .forEach((h: SortableTableHeaderDirective) => h.reset());

                // sort and emit the transformed data
                this.sort.emit(this.sortData(this.data, sortData));
            });
        });
    }

    ngOnDestroy(): void {
        this.headers.forEach((header: SortableTableHeaderDirective) => {
            header.sort.unsubscribe();
        });
    }

    ngOnInit(): void {
        //
    }

    sortData(data: any, sortData: ColumnSortData): any {
        if (!data) {
            return data;
        }

        if (sortData.sortDirection === ColumnSortDirection.None) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            let previousPropertyVal = get(previous, sortData.sortProperty, '0');
            let currentPropertyVal = get(current, sortData.sortProperty, '0');

            if (previousPropertyVal == null) {
                previousPropertyVal = '0';
            }

            if (currentPropertyVal == null) {
                currentPropertyVal = '0';
            }

            if (previousPropertyVal > currentPropertyVal) {
                return sortData.sortDirection === ColumnSortDirection.Desc ? -1 : 1;
            } else if (previousPropertyVal < currentPropertyVal) {
                return sortData.sortDirection === ColumnSortDirection.Asc ? -1 : 1;
            } else if (previousPropertyVal !== currentPropertyVal) {
                return sortData.sortDirection === ColumnSortDirection.Asc ? -1 : 1;
            }

            return 0;
        });
    }

    private getDefaultValue(val: any): void {
        //
    }

    private getProp(obj: any, propExpression: string): void {
        //
    }
}
